import { useEffect, useState } from "react";

import { paymentRequests } from "@/api/(requests)/payment";
import { sharedRequests } from "@/api/(requests)/shared";

export const usePatient = (patientId, existingPatient) => {
  const [patient, setPatient] = useState();

  useEffect(() => {
    const getPatient = async () => {
      // if a existing patient is passed in
      // we do not need to make another network call
      if (existingPatient) {
        setPatient(existingPatient);

        return;
      }
      if (!patientId) {
        return;
      }
      const urlParams = { patientId };
      const patientDetails = await sharedRequests.fetch_patient_details({ urlParams });

      setPatient(patientDetails.user);
    };

    getPatient();
  }, [patientId]);

  return patient;
};

const usePatientDiagnosis = (patientId, existingDiagnosis) => {
  const [diagnosis, setDiagnosis] = useState();

  useEffect(() => {
    const getDiagnosis = async () => {
      // if an existing diagnosis is passed in
      // we do not need to make another network call
      if (existingDiagnosis) {
        setDiagnosis(existingDiagnosis);

        return;
      }
      if (!patientId || existingDiagnosis) {
        return existingDiagnosis;
      }
      const urlParams = { patientId };
      const diagnosisResponse = await sharedRequests.get_patient_diagnosis({ urlParams });

      setDiagnosis(diagnosisResponse);
    };

    getDiagnosis();
  }, [patientId]);

  return diagnosis;
};

export const usePaymentMethod = (patientId) => {
  const [paymentInfo, setPaymentInfo] = useState();

  useEffect(() => {
    const getPaymentMethod = async () => {
      if (!patientId) {
        return undefined;
      }

      const paymentInfoResponse = await paymentRequests.fetchPatientCardInfo({
        data: { patient_id: patientId },
      });

      setPaymentInfo(paymentInfoResponse);
    };

    getPaymentMethod();
  }, [patientId]);

  return paymentInfo;
};
